// extracted by mini-css-extract-plugin
module.exports = {"main":"Dashboard__main--wPK0m","container":"Dashboard__container--3qGvt","content":"Dashboard__content--1v9Q3"};